/**
 * Mobile dashboard due-stats stack — sites / repairs.
 *
 * Presentational: the caller owns counting and calendar-month filtering.
 * Hides the two-row layout, the danger treatment on repairs, and the
 * fixed uppercase labels from the design reference.
 *
 * Props:
 *   sitesDue   — sites due for testing in the current calendar month
 *   repairsDue — open repairs count
 *   isLoading  — shows placeholders instead of numbers
 *   className  — extra class(es) on the root
 */
function displayValue(value, isLoading) {
  if (isLoading || value == null) return '…';
  return value;
}

export default function MobileDashboardStatsCard({
  sitesDue,
  repairsDue,
  isLoading = false,
  className = '',
}) {
  const classes = ['mobile-dashboard-stats', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="group" aria-label="Due this month">
      <div className="mobile-dashboard-stats-row">
        <span className="mobile-dashboard-stats-value">
          {displayValue(sitesDue, isLoading)}
        </span>
        <span className="mobile-dashboard-stats-label">Sites due this month</span>
      </div>
      <div className="mobile-dashboard-stats-row mobile-dashboard-stats-row--danger">
        <span className="mobile-dashboard-stats-value">
          {displayValue(repairsDue, isLoading)}
        </span>
        <span className="mobile-dashboard-stats-label">Repairs due</span>
      </div>
    </div>
  );
}
